// src/hooks/useNavigation.js
import { useState } from 'react';

/**
 * Custom hook to handle navigation state in the app
 */
const useNavigation = () => {
  const [currentScreen, setCurrentScreen] = useState('home');
  const [selectedSalon, setSelectedSalon] = useState(null);
  const [selectedSpecialist, setSelectedSpecialist] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  
  // Navigation handler
  const navigateTo = (screen, params = {}) => {
    if (params.salon) setSelectedSalon(params.salon);
    if (params.specialist) setSelectedSpecialist(params.specialist);
    if (params.service) setSelectedService(params.service);
    if (params.date) setSelectedDate(params.date);
    if (params.time) setSelectedTime(params.time);
    if (params.appointment) setSelectedAppointment(params.appointment);
    setCurrentScreen(screen);
  };
  
  // Check if the screen should show bottom navigation
  const shouldShowBottomNav = () => {
    return ![
      'salon', 
      'specialists', 
      'services', 
      'selectDate', 
      'confirmation',
      'appointmentDetails' // Adăugat appointmentDetails, care nu ar trebui să afișeze bară de navigare
    ].includes(currentScreen);
  };
  
  return {
    currentScreen,
    selectedSalon,
    selectedSpecialist,
    selectedService,
    selectedDate,
    selectedTime,
    selectedAppointment,
    navigateTo,
    shouldShowBottomNav
  };
};

export default useNavigation;